import { render, staticRenderFns } from "./BatchAssignTodoItems.vue?vue&type=template&id=2d6063b3"
import script from "./BatchAssignTodoItems.vue?vue&type=script&lang=js"
export * from "./BatchAssignTodoItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports